import { getCookie, setCookie } from 'cookies-next/client';

import {
  cookieKeys,
  getSubscriptionCookieCode,
  subscriptionCookieSplitter,
} from './cookies.common.ts';

const getSubscriptionCookie = () => {
  return getCookie(cookieKeys.subscriptions);
};

export const setSubscriptionCookie = (subscriptionCode: string) => {
  const code = getSubscriptionCookieCode(subscriptionCode);
  let subscriptionCodes = getSubscriptionCookie();

  if (!subscriptionCodes) {
    subscriptionCodes = code;
  } else if (!subscriptionCodes.includes(code)) {
    subscriptionCodes += `${subscriptionCode}${subscriptionCookieSplitter}`;
  }

  setCookie(cookieKeys.subscriptions, subscriptionCodes, {
    secure: true,
  });
};

export const isCodeInSubscriptionCookie = (subscriptionCode: string) => {
  const subscriptionCookie = getSubscriptionCookie();
  if (!subscriptionCookie) {
    return false;
  }

  const code = getSubscriptionCookieCode(subscriptionCode);
  return subscriptionCookie.includes(code);
};
